<template>
  <tr colspan="3">
    <td class="table-td border-r border-opacity-20">#</td>
    <td class="table-td border-r border-opacity-20" style="padding: 3px;">
      <vehicleSelect
        v-model="vehicle"
        :optList="getFilterVehicle"
        :load="vehicleLoad"
        :sorted="activeList != null || activeList <= vehicleList ? true : false"
        :products="products"
        :customers="customers"
        :order="order"
        :isBulk="activeList != null || activeList <= vehicleList ? true : false"
        :selectedVehicles="selectedVehicles"
        :vehicleType="vehicleType"
        @isVehicleConflictModalVisible="(val)=>$emit('isVehicleConflictModalVisible',val)"
        :style="{ width: '170px',marginLeft: '5px'}"
      />
    </td>
    <td class="table-td border-r border-opacity-20">
      {{ vehicle?.address || "" }}
    </td>
    <td class="table-td border-r border-opacity-20">
      {{ vehicle?.washPointName || "" }}
    </td>
    <td class="table-td border-r border-opacity-20">
      <span v-if="vehicle?.washCost >= 0">{{ vehicle.washCost }}</span>
    </td>
    <td class="table-td border-r border-opacity-20">
      <span v-if="vehicle?.recomendationTotalCost >= 0">
        {{ vehicle.recomendationTotalCost }}
      </span>
    </td>
    <td class="table-td border-r border-opacity-20">
      <span v-if="vehicle?.allCost !== undefined && vehicle?.allCost !== null">
        {{ vehicle.allCost.toFixed(2) }}
      </span>
    </td>
    <td class="text-center">
      <button
        type="button"
        class="process-btn bg-gray-800 bg-gradient-to-br from-gray-800 to-gray-600 p-6 rounded-xl border border-gray-100"
        style="padding: 7px 20px 7px 20px; border-radius: 8px; border-width:1px;"
        @click="addItem"
        :disabled="!vehicle"
      >
        <i class="fas fa-plus mr-0.5"></i> Ekle
      </button>
    </td>
  </tr>
</template>

<script>
import { calculator } from "../../../utils/cost";
import { calculateDistancePriority, isWashStatus ,isSequential} from "@/utils/recomendation/index";
import { checkCargoCompatibility } from "@/utils/recomendation/controller/checkCargoCompatibility";
import vehicleSelect from "../../../views/operations/orders/components/vehicle-select.vue";

export default {
  name: "new-vehicle-row",

  components: {
    vehicleSelect,
  },

  props: [
    "order",
    "products",
    "customers",
    "vehicleList",
    "activeList",
    "selectedVehicles",
    "vehicleType",
    "requiredEquipmentCategories"
  ],

  data() {
    return {
      vehicle: null,
      vehicleLoad: false,
      calculationInProgress: false,
    };
  },

  computed: {
    getFilterVehicle() {
      return this.vehicleList?.map((item) => ({
        ...item,
        name: item.vehicle,
        isRent: item?.haveType,
      }));
    },
  },

  methods: {
    checkVehicleEquipment(vehicle) {
      const result = {
        hasEquipmentRequirements: true,
        missingRequiredEquipment: [],
        insufficientRequiredEquipment: []
      };

      if (!this.requiredEquipmentCategories || this.requiredEquipmentCategories.length === 0) {
        result.hasEquipmentRequirements = false;
        return result;
      }

      // Gerekli ekipman kategorilerini kontrol et
      this.requiredEquipmentCategories.forEach(category => {
        const categoryLabel = this.getCategoryLabel(category);

        // Aracın bu kategoride ekipmanı var mı kontrol et
        // vehicle.inventory dizisinde bu kategoriyi ara
        const vehicleEquipment = vehicle.inventory?.filter(eq => eq.category === category) || [];

        if (vehicleEquipment.length === 0) {
          // Bu kategoride hiç ekipman yok
          result.missingRequiredEquipment.push({
            category: categoryLabel,
            required_quantity: 1
          });
        } else {
          // Ekipman var ama yeterli mi?
          // Backend'den gelen veri yapısına göre kontrol et
          // Eski yapı: current_location === 'ARACTA' && is_deleted === 0
          // Yeni yapı: status === 'AKTIF'
          const availableQuantity = vehicleEquipment.filter(eq => {
            // Yeni yapı kontrolü (status field'ı varsa)
            if (eq.status !== undefined) {
              return eq.status === 'AKTIF';
            }
            // Eski yapı kontrolü (geriye dönük uyumluluk için)
            if (eq.current_location !== undefined) {
              return eq.current_location === 'ARACTA' && eq.is_deleted === 0;
            }
            // Field yoksa tüm ekipmanları say
            return true;
          }).length;

          result.insufficientRequiredEquipment.push({
            category: categoryLabel,
            available_quantity: availableQuantity,
            required_quantity: 1
          });
        }
      });

      return result;
    },

    getCategoryLabel(category) {
      const labels = {
        'POMPA&HORTUM&DUSURUCU': 'Pompa & Hortum & Düşürücü',
        'GUVENLIK': 'Güvenlik Ekipmanı',
        'YEDEK_PARCA': 'Yedek Parça',
        'DIGER': 'Diğer'
      };
      return labels[category] || category;
    },

    async calculateCost(vehicleParameter) {
      if (!this.vehicle || this.calculationInProgress) return null;

      this.calculationInProgress = true;

      const distancePriority = calculateDistancePriority(
        this.order,
        this.vehicle
      );
      const distance = parseFloat(distancePriority).toFixed(2);

      try {
        const cost = await calculator(
          this.$store.state.userData.token,
          1,
          1,
          vehicleParameter||this.vehicle,
          this.order,
          distance,
          0,
          true,
          true,
          1,
          distance / 50
        );
        return {
          ...this.vehicle,
          distance: distance,
          washPointName: cost.washPointName,
          recomendationTotalCost: Number(cost.total),
          washCost: Number(cost.totalWashPriceCost),
          allCost: Number(cost.total) + Number(cost.totalWashPriceCost),
          distanceWithWashing:cost?.distanceWithWashing,
          washPointNotExist: cost?.washPointNotExist,
        };
      } catch (error) {
        console.error(
          `Failed to calculate cost for vehicle ${
            this.vehicle?.id || "unknown"
          }:`,
          error
        );
        return null;
      } finally {
        this.calculationInProgress = false;
      }
    },

    async addItem() {
      if (!this.vehicle) return;

      try {
        this.vehicleLoad = true;

        // Calculate cost if not already calculated
        if (!this.vehicle.recomendationTotalCost) {
          const costData = await this.calculateCost();
          if (costData) {
            this.vehicle = { ...this.vehicle, ...costData };
          }
        }

        this.$emit("addItem", this.vehicle);
        this.vehicle = null;
      } catch (error) {
        console.error("Error adding vehicle:", error);
      } finally {
        this.vehicleLoad = false;
      }
    },

    async calculateRealDistanceAsync(vehicle) {
      if (!vehicle || !this.order) return;

      try {
        const { realRouteDistance } = require('@/utils/recomendation/realRouteDistance');

        const fromLocation = {
          lat: parseFloat(vehicle.latitude || 0),
          lng: parseFloat(vehicle.longitude || 0)
        };

        const orderLocation = {
          lat: parseFloat(this.order.outpointLat || this.order.fillingLatitude || 0),
          lng: parseFloat(this.order.outpointLng || this.order.fillingLongitude || 0)
        };

        if (!fromLocation.lat || !fromLocation.lng || !orderLocation.lat || !orderLocation.lng) {
          return;
        }

        // Arka planda OSRM mesafesini hesapla ve cache'e kaydet
        await realRouteDistance(fromLocation, orderLocation, true);
      } catch (error) {
        // Hata durumunda sessizce devam et
      }
    },
  },

  watch: {
    requiredEquipmentCategories: {
      handler() {
        // Ekipman gereksinimleri değiştiğinde vehicle bilgisini force update et
        if (this.vehicle) {
          this.$forceUpdate();
        }
      },
      deep: true
    },
    vehicle: {
      async handler(newValue, oldValue) {
        // Only calculate if we have a new vehicle selected and it doesn't already have costs calculated
        if (
          newValue &&
          (!newValue.recomendationTotalCost || !newValue.washCost) &&
          JSON.stringify(newValue) !== JSON.stringify(oldValue)
        ) {
          let vehicleFromVehicleList = this.vehicleList.find((item) => item.plate === this.vehicle.plate)
          
          if(!("productId" in this.order)){
            this.order.productId = this.products.find((item) => item.name.trim() === this.order.productType.trim()).id;
          }

          const isVehicleSequel = vehicleFromVehicleList.orderNos.length > 0 
                    ? isSequential(vehicleFromVehicleList, {
                      ...this.order,
                      startLat: this.order.outpointLat,
                      startLng: this.order.outpointLng,
                      endLat: this.order.targetPointLat,
                      endLng: this.order.targetPointLng,
                    })
                    : false;  
          
          const isWashing=isWashStatus(
              this.customers,
              this.products,
              {...vehicleFromVehicleList,isSequentialTrue:isVehicleSequel},
              this.order
            ).status

          // Müşteri bazlı kargo uyumluluğunu kontrol et
          const vehicleLastProduct = vehicleFromVehicleList.lastProduct || vehicleFromVehicleList.productId;
          const cargoCompatibility = checkCargoCompatibility(
            vehicleLastProduct,
            this.customers,
            this.order.customer
          );

          // OSRM mesafesini arka planda hesapla ve cache'e kaydet
          this.calculateRealDistanceAsync(vehicleFromVehicleList);

          // Ekipman kontrolü
          const isEquipmentBased = this.requiredEquipmentCategories && this.requiredEquipmentCategories.length > 0;
          let equipmentCheckResult = {
            hasEquipmentRequirements: false,
            missingRequiredEquipment: [],
            insufficientRequiredEquipment: []
          };

          if (isEquipmentBased) {
            equipmentCheckResult = this.checkVehicleEquipment(vehicleFromVehicleList);
          }

          const costData = await this.calculateCost(
            {...vehicleFromVehicleList,isSequentialTrue:isVehicleSequel, recomendation:{isWashing}}
          );
          if (costData) {
            // Use Object.assign to avoid triggering the watcher again
            this.vehicle = {
              ...this.vehicle,
              ...costData,
              isEquipmentBased,
              recomendation:{
                isWashing,
                isIncompatible: !cargoCompatibility.isCompatible,
                incompatibilityReason: cargoCompatibility.reason,
                rejectedProduct: cargoCompatibility.rejectedProduct,
                ...equipmentCheckResult
              }
            };
          }
        }
      },
      deep: true,
    },
  },
};
</script>
